<template>
  <b-modal
    ref="historyModal"
    title="Lịch sử phiếu đề nghị mua hàng"
    size="lg"
    hide-footer
  >
    <b-table
      v-if="histories && histories.length"
      :items="histories"
      :fields="historyFields"
      bordered
      hover
      small
    >
      <template #cell(createdAt)="data">
        {{ formatDateTime(data.value) }}
      </template>
      <template #cell(updatedBy)="data">
        {{ data.item.updatedByName || data.value }}
      </template>
    </b-table>

    <p v-else class="text-muted mb-0">Chưa có lịch sử.</p>
  </b-modal>
</template>

<script>
import moment from 'moment';

export default {
  name: 'PurchaseRequestHistoryModal',
  props: {
    histories: {
      type: Array,
      default: () => [],
    },
    /**
     * Nếu muốn custom cột (mặc định đang theo `Detail.vue` hiện tại)
     */
    fields: {
      type: Array,
      default: null,
    },
  },
  computed: {
    historyFields() {
      if (this.fields && this.fields.length) return this.fields;
      return [
        { key: 'createdAt', label: 'Lúc', thStyle: { width: '25%' } },
        { key: 'actionLabel', label: 'Hành động', thStyle: { width: '15%' } },
        { key: 'description', label: 'Chi tiết' },
        {
          key: 'updatedBy',
          label: 'Người thực hiện',
          thStyle: { width: '20%' },
        },
      ];
    },
  },
  methods: {
    open() {
      this.$refs.historyModal.show();
    },
    formatDateTime(val) {
      return val ? moment(val).format('DD/MM/YYYY HH:mm') : '';
    },
  },
};
</script>

